import React from 'react';
import {
  HStack, Button, ButtonIcon, ButtonText,
} from '@gluestack-ui/themed';
import { ExternalLink, Copy, Check } from 'lucide-react-native';
import { useNavigation } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { isLiveKitSlot } from '@/common/utils/oralExam/liveKitSlot';
import { createClipboardHandler } from '../utils/slotUtils';

/**
 * SlotMeetingActions — Join Room navigates to /meeting/slot/:slotId so a
 * refresh stays in the sitting. Teams links still open in a new tab.
 */
const SlotMeetingActions = ({ slot }) => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const [copiedItems, setCopiedItems] = React.useState(new Set());
  const { copyToClipboard } = createClipboardHandler(setCopiedItems);
  const isLiveKit = isLiveKitSlot(slot);

  const handleJoinMeeting = () => {
    if (typeof window !== 'undefined' && slot.videoMeetingJoinUrl) {
      window.open(slot.videoMeetingJoinUrl, '_blank');
    }
  };

  const handleLiveKitJoin = () => {
    if (!slot?.slotId) return;
    navigation.navigate('SlotMeetingScreen', { slotId: slot.slotId });
  };

  return (
    <HStack space="sm">
      {isLiveKit && (
        <Button
          flex={1}
          size="sm"
          variant="solid"
          testID="lecturer-join-oral-exam"
          onPress={handleLiveKitJoin}
        >
          <ButtonText size="sm">{t('oralExam.joinRoom')}</ButtonText>
        </Button>
      )}

      {slot.videoMeetingJoinUrl && !isLiveKit && (
        <Button flex={1} onPress={handleJoinMeeting} size="sm" variant="solid">
          <ButtonIcon as={ExternalLink} size="xs" color="$white" mr="$1" />
          <ButtonText size="sm">{t('lecturer.eventCalendar.sidebar.buttons.joinMeeting')}</ButtonText>
        </Button>
      )}

      {slot.videoMeetingId && (
        <Button flex={1} size="xs" variant="outline" onPress={() => copyToClipboard(slot.videoMeetingId, 'meetingId')}>
          <ButtonIcon
            as={copiedItems.has('meetingId') ? Check : Copy}
            mr="$1"
            color={copiedItems.has('meetingId') ? '$statusSuccess' : '$textSubtle'}
          />
          <ButtonText>{t('lecturer.eventCalendar.sidebar.buttons.copyId')}</ButtonText>
        </Button>
      )}
    </HStack>
  );
};

export default SlotMeetingActions;
